
import {switchMap, take} from 'rxjs/operators';
/**
 * Created by christiancueni on 07/07/16.
 * Copyright (c) 2016 ITerativ GmbH. All rights reserved.
 */
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HelloClassApiService } from '../services/helloclass'
import { ALLOW_TEST_USER } from '../app.constants';

@Component({
    selector: 'hc-testuser-page',
    template: `
        <div>
            <p *ngIf="key !== ''" class="qa-testkey">{{key}}</p>
        </div>
    `
})
export class TestUserPage {
    public key = ''

    constructor(private activatedRoute: ActivatedRoute, private hcService: HelloClassApiService) {
    }

    ngOnInit() {
        if (ALLOW_TEST_USER) {
            this.activatedRoute.queryParams.pipe(
                take(1),
                switchMap((params: any) => this.hcService.testUser(params['email'])),)
                .subscribe((data: any) => {
                    this.key = data.key;
                });
        }
    }

}
